export default "<div class=\"widget\">\r\n    <app-assignee-payslips [assignee]=\"assignee\"></app-assignee-payslips>\r\n</div>\r\n"